// 加密方式
const algorithm = "aes";

import request from "@/utils/request";
// import Cookies from 'js-cookie'
// export function login(data) {
//   return request({
//     url: '/api/v1/uaa/login',
//     method: 'post',
//     data,
//     headers: { 'X-Requested-With': 'XMLHttpRequest' }
//   })
// }

export function getInfo(accountId) {
  return request({
    url: `/api/v1/organization/employee/${accountId}/employee-detail`,
    method: "get",
  });
}

// export function logout() {
//   // console.log(logout, '/api/v1/uaa/logout')
//   return request({
//     url: '/api/v1/authentication/logout',
//     method: 'get'
//   })
// }

// export function fetchRadom() {
//   return request({
//     url: '/api/v1/common/secret',
//     method: 'get'
//   })
// }

export function fetchAesRadom() {
  return request({
    url: "/api/v1/common/secret",
    method: "post",
    data: {
      algorithm: algorithm,
    },
  });
}

export function getAccountId() {
  return request({
    url: "/api/v1/authentication/user",
    method: "get",
  });
}

// export function getNcAppKey() {
//   return request({
//     url: '/api/v1/uaa/getNcAppKey',
//     method: 'get'
//   })
// }

// export function sendForgetEmail(data) {
//   return request({
//     url: '/api/v1/uaa/sendForgetEmail',
//     method: 'post',
//     data
//   })
// }

// export function checkCodeForPassword(data) {
//   return request({
//     url: '/api/v1/uaa/checkCodeForPassword',
//     method: 'post',
//     data
//   })
// }

// export function resetPasswordAfterCheckCode(data) {
//   return request({
//     url: '/api/v1/uaa/resetPasswordAfterCheckCode',
//     method: 'post',
//     data
//   })
// }

export function fetchDomain() {
  return request({
    url: "/custom/anonymous/domain.json",
    method: "get",
  });
}

export function getAppMenuTree(params) {
  return request({
    url: "/api/v1/user/privilege/menu/app-menu-tree",
    method: "get",
    params,
  });
}

// export function getSelfApps() {
//   return request({
//     url: '/api/v1/user/oauth-application',
//     method: 'get'
//   })
// }

// 获取应用列表
export function getSelfApps(domain) {
  return request({
    url: "/api/v1/common/user/oauth-application",
    method: "GET",
    baseUrl: domain,
  });
}

export function getButtons(pageId) {
  return request({
    url: "/api/v1/user/privilege/menu/buttons",
    method: "get",
    params: { pageId },
  });
}

export function logout() {
  return request({
    url: "/api/v1/authentication/logout",
    method: "get",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });
}
export function getToken(params) {
  return request({
    url: "/api/v1/authentication/oauth/token",
    method: "get",
    params,
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js